import { IonButton, IonIcon } from "@ionic/react";
import { cloudDownloadOutline } from "ionicons/icons";
import React, { useState } from "react";
import { Document } from "../@types/document";
import api from "../utils/api";

interface ComponentProps {
  document: Document;
}

export const DocumentDownloadButton: React.FC<ComponentProps> = ({ document }) => {
  const [filename, setFilename] = useState<string | null>(null);

  const handleDownload = async () => {
    const docId = (document.signedArchive || document.archive)?.id;
    let archiveFilename = document.archive?.filename;
    const extension = document.archive?.extension || ".pdf"; // Usar la extensión del documento o .pdf por defecto

    if (!docId) {
      console.error("No document ID found for download");
      return;
    }

    if (!archiveFilename) {
      console.error("No filename found for document");
      return;
    }

    // Verifica si el archivo ya tiene una extensión, si no, agrega la extensión
    if (!archiveFilename.includes('.')) {
      archiveFilename += extension;
    }

    try {
      const token = localStorage.getItem('token');
      if (!token) {
        console.error('No token found');
        return;
      }

      const response = await fetch(`${api.baseURL}archive/${docId}`, {
        headers: {
          'Authorization': `Bearer ${token}`,
        },
      });

      if (!response.body) {
        throw new Error('No response body found');
      }

      const reader = response.body.getReader();
      if (!reader) {
        throw new Error('No readable stream found');
      }

      const stream = new ReadableStream({
        start(controller) {
          function push() {
            reader.read().then(({ done, value }) => {
              if (done) {
                controller.close();
                return;
              }
              controller.enqueue(value);
              push();
            }).catch(error => {
              console.error('Stream read error:', error);
              controller.error(error);
            });
          }
          push();
        }
      });

      const blob = await new Response(stream).blob();
      const url = URL.createObjectURL(blob);
      setFilename(archiveFilename);

      // Crear un enlace y disparar el click programáticamente
      const a = window.document.createElement('a');
      a.href = url;
      a.download = archiveFilename;
      window.document.body.appendChild(a);
      a.click();
      window.document.body.removeChild(a);

      // Liberar la URL del objeto después de la descarga
      URL.revokeObjectURL(url);
    } catch (error) {
      console.error('Fetch error:', error);
    }
  };

  return (
    <IonButton onClick={handleDownload}>
      <IonIcon icon={cloudDownloadOutline}></IonIcon>
      Descargar Documento
    </IonButton>
  );
};